import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {send_getcv_cmd, send_setcv_cmd} from "../etc/cmd";
import { TbReload } from "react-icons/tb";

// LokSound 5                               33554582
// LokSound 5 DCC                   33554588
// LokSound 5 micro                   33554587
// LokSound 5 micro DCC           33554590
// LokSound 5 micro DCC Direct  16777370
// LokSound 5 L                          33554589
// LokSound 5 L DCC                  33554592
// LokSound 5 XL                         33554591

// 33554495 (0x0200003F) = LokPilot V4.0
// 33554498 (0x02000042) = LokPilot V4.0 DCC

// ESU LokPilot 5	255	255	33554600,33554636

const decoder = {
    '145': {
        '4': {
            '124': 'MN170',
        },
        '40': {
            '177': 'MX617',
            '197': 'MX617',

            '181': 'MX618',
            '195': 'MX616',

            '199': 'MX600',

            '201': 'MX620',
            '210': 'MX640',
            '211': 'MX630-P2520',
            '213': 'MX631',
            '218': 'MX630 (2011)',

            '223': 'MX621',

            '228': 'MX681',

            '233': 'MX622',
            '234': 'MX623',
            '246': 'MX658',
        }
    },
    '151':
        {
            '33554582': 'LokSound 5',
            '33554588': 'okSound 5 DCC',
            '33554587': 'LokSound 5 micro',
            '': '',
            '33554600': 'LokPilot 5',
            '33554636': 'LokPilot 5',

            '33554497': 'LokSound Micro V4.0 Next18', // unshure
        }

}

function getModelString(man, ver, mod) {
    let sver = ver

    if (parseInt(sver) > 20) {
        sver = 40
    }


    if (decoder[man]) {

        if (man === 151) {
            if (decoder[man][mod]) {
                return decoder[man][mod]
            }
        }

        if (decoder[man][sver]) {
            if (decoder[man][sver][mod]) {
                return decoder[man][sver][mod]
            }
        }
    }

    return '|' + man + '|' + ver + '|' + mod + '|'
}


const LcInfo = ({lc}) => {

    const [cvrequ, setCvReq] = useState(false);

    function requestCv() {
        setCvReq(false);

        let cc = {
            'lcid': lc.id,
            'cvnr': 8
        }
        send_getcv_cmd(cc);
        let cc7 = {
            'lcid': lc.id,
            'cvnr': 7
        }
        send_getcv_cmd(cc7);
    }


    if (!cvrequ) {

        if (getCV(8) === 145) {
            setCvReq(true);
            //console.log("MORE ZIMO +++++++++++++++++++++++++++++++++ > > >")
            let cc65 = {
                'lcid': lc.id,
                'cvnr': 65
            }
            send_getcv_cmd(cc65);

            let cc250 = {
                'lcid': lc.id,
                'cvnr': 250
            }
            send_getcv_cmd(cc250);
        }

        if (getCV(8) === 151) {
            setCvReq(true);
            //console.log("MORE ESU +++++++++++++++++++++++++++++++++ > > >")

            // ProId = (CV264 * 16777216) + (CV263 * 65536) +(CV262 * 256) + CV261

            {
                let cc = {
                    'lcid': lc.id,
                    'cvnr': 31,
                    'cvval': 0
                }
                send_setcv_cmd(cc);
            }
            {
                let cc = {
                    'lcid': lc.id,
                    'cvnr': 32,
                    'cvval': 255
                }
                send_setcv_cmd(cc);
            }


            {
                let cc = {
                    'lcid': lc.id,
                    'cvnr': 264
                }
                send_getcv_cmd(cc);
            }
            {
                let cc = {
                    'lcid': lc.id,
                    'cvnr': 263
                }
                send_getcv_cmd(cc);
            }
            {
                let cc = {
                    'lcid': lc.id,
                    'cvnr': 262
                }
                send_getcv_cmd(cc);
            }
            {
                let cc = {
                    'lcid': lc.id,
                    'cvnr': 261
                }
                send_getcv_cmd(cc);
            }
        }
    }


    function getCV(num) {
        if (lc && lc.cv) {

            const cv = lc.cv.find((itm) => {
                return parseInt(itm.id) === parseInt(num);
            })

            if (cv) {
                return cv.cvval
            }

            return undefined
        }
        return undefined
    }

    function getManu(num) {
        if (num === 145) {
            return "ZIMO"
        } else if (num === 151) {
            return "ESU"
        }
        return num ? num.toString() : undefined
    }

    let versionstring = null
    let model = null

    //console.log(lc)
    //console.log(lc.cv)

    const man = getCV(8)
    if (man === 145) { // ZIMO
        let m = getCV(250)
        let vers = getCV(7)

        if ((m && m !== 0 && m !== '0') && man && vers) {

            // console.log(man + " - " + vers + " - " + m)

            model = getModelString(man, vers, m) // decoder[man][vers][m]
            if (!model) {
                model = m
            }

            versionstring = getCV(7) + '.' + getCV(65)

        } else {

            model = man + " - " + vers + " - " + m
        }


    }
    if (man === 151) { // ESU

        let prodId = '-'
        /*
                console.log('31', getCV(31));
                console.log('32', getCV(32));

                console.log('264', getCV(264));
                console.log('263', getCV(263));
                console.log('262', getCV(262));
                console.log('261', getCV(261));
        */
        if (getCV(264) && getCV(263) && getCV(262) && getCV(261)) {
            prodId = (parseInt(getCV(264)) * 256 * 256 * 256)
                + (parseInt(getCV(263)) * 256 * 256)
                + (parseInt(getCV(262)) * 256)
                + (parseInt(getCV(261)))
        }

        model = getModelString(man, 0, prodId)
    }

    return (
        <div
            style={{
                fontSize: '12px',
                color: '#000000',
                fontFamily: 'monospace',

                minHeight: '25px',
                width: 'auto',
                margin: '7px',
                padding: '5px',
                paddingTop: '+5px',
                marginBottom: '-3px',
                border: 'var(--border)',
                background: 'var(--inner-background)',
            }}
        >

            <div style={{
                margin: '2px',
                float: 'right'
            }} title='load' className={'bubble'} onClick={requestCv}><TbReload/></div>


            <div style={{
                fontWeight: 'bold',
                margin: '10px',
            }}>{getManu(getCV(8))} {model}</div>
            <div style={{
                margin: '10px',
            }}>{versionstring ? 'Version: ' + versionstring : null}</div>

        </div>
    )
}

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LcInfo)
